import { render, staticRenderFns } from "./OrganizerInfo.vue?vue&type=template&id=5b510acd&scoped=true"
import script from "./OrganizerInfo.vue?vue&type=script&lang=js"
export * from "./OrganizerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b510acd",
  null
  
)

export default component.exports